// Module scripts execute once per URL, even when several cards render the tag.
// Reuse Dawn's existing script on product pages; load it on card-only pages.
const source = document.querySelector('script[data-rf-product-form-src]').dataset.rfProductFormSrc;
const url = new URL(source, document.baseURI).href;
if (!customElements.get('product-form') && !Array.from(document.scripts).some((script) => script.src === url)) {
  const script = document.createElement('script');
  script.src = url;
  document.head.append(script);
}
